import React, { useRef, useState, useEffect } from "react";
import {
  List,
  ListItem,
  Divider,
  Button,
  IconButton,
  Snackbar,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EventRepeatIcon from "@mui/icons-material/EventRepeat";
import { MainButton, FilterButton, TableButton } from "../SXStyle";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import {
  eliminarInvitacion,
  obtenerListadoInvitaciones,
} from "../service/apiService";
import { setItems as setInvitacionsItem } from "../provider/Slice/InvitationSlice";
import { useAppDispatch, useAppSelector } from "../provider/app/hooks";
import DialogInvitationGroup from "../components/adminsuite/DialogInvitationGroup";
import DialogMisGrupos from "./adminsuite/DialogMisGrupos";
import DialogMisLicencias from "./adminsuite/DialogMisLicencias";
import { useNavigate } from "react-router-dom";
import "./style.css";

function AdminCard({ name, data, button1_name, button2_name, reload }) {
  const dispatch = useAppDispatch();

  //snackbar de alertas
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
  });

  //dialog
  const [openInvitationGroup, setOpenDialogInvitationGroup] = useState(false);
  const [openMemberShip, setOpenMemberShip] = useState(false);
  const [openMisLicencias, setOpenMisLicencias] = useState(false);

  //registro seleccionado
  const [registroSeleccionado, setRegistroSeleccionado] = useState(null);

  const [openLoader, setOpenLoader] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    // Cuando data cambie y no esté vacío, quitamos loading
    if (data !== null) {
      setOpenLoader(false);
    } else {
      setOpenLoader(true);
    }
  }, [data]);

  const onClick1 = (option, item) => {
    switch (option) {
      case "Grupos":
        navigate(`/admin-suite/members?id=${item.id}`);
        break;

      case "Usuarios":
        //ve la seccion de los grupos que tiene un usuario
        setOpenMemberShip(true);
        setRegistroSeleccionado(item);
        break;

      default:
        console.log("sin funcion");
        break;
    }
  };

  const onClick2 = async (option, item) => {
    switch (option) {
      //ve la seccion de invitar a usuarios al grupo seleccionado
      case "Grupos":
        setRegistroSeleccionado(item.id);
        setOpenDialogInvitationGroup(true);
        break;

      case "Usuarios":
        //ve la seccion de licencias que tiene un usuario
        setOpenMisLicencias(true);
        setRegistroSeleccionado(item);
        break;

      case "Invitaciones":
        const response = await eliminarInvitacion(item.id);

        const resultList = await obtenerListadoInvitaciones();
        dispatch(setInvitacionsItem(resultList.data));

        setSnackbar({ message: response?.message, open: true });
        break;
    }
  };

  const devolverNombre = (name, item) => {
    switch (name) {
      case "Usuarios":
        return item.fullname;

      default:
        return item.name;
    }
  };

  const onViewClick = (option) => {
    switch (option) {
      case "Grupos":
        navigate(`/admin-suite/groups`);
        break;

      case "Usuarios":
        navigate(`/admin-suite/users`);
        break;

      case "Usuarios":
        navigate(`/admin-suite/users`);
        break;

      case "Invitaciones":
        navigate(`/admin-suite/invitations`);
        break;

      case "Licencias":
        navigate(`/admin-suite/licenses`);
        break;
    }
  };

  //cierra el snackbar
  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" className="text-amarillo" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <div className="w-full rounded-lg shadow-xl bg-ceniza_light border-gray-700">
      <DialogInvitationGroup
        open={openInvitationGroup}
        setOpen={setOpenDialogInvitationGroup}
        setSnackbar={setSnackbar}
        registroSeleccionado={registroSeleccionado}
      />

      <DialogMisGrupos
        open={openMemberShip}
        setOpen={setOpenMemberShip}
        setSnackbar={setSnackbar}
        registroSeleccionado={registroSeleccionado}
      />

      <DialogMisLicencias
        open={openMisLicencias}
        setOpen={setOpenMisLicencias}
        setSnackbar={setSnackbar}
        registroSeleccionado={registroSeleccionado}
      />

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        ContentProps={{
          sx: {
            color: "#fffcfc",
          },
        }}
      />

      <div className="p-4 space-y-4 ">

        {/* Loader */}
        {openLoader && (
          <div className="items-center justify-center content-center ml-[50%] mt-[5%]">
            <CircularProgress sx={{ color: "#cb9636" }} />
          </div>
        )}

        {!openLoader && (
          <>
            {/* Encabezados */}
            <div className="flex">
              <h2 className="text-xl font-bold leading-tight tracking-tight  text-blanco text-center mr-5">
                {name}
              </h2>

              <div className="flex ml-auto">
                <Button
                  variant="contained"
                  endIcon={<VisibilityIcon fontSize="small" />}
                  onClick={() => onViewClick(name)}
                  sx={{
                    ...MainButton,
                    width: "70px",
                    height: "25px",
                    fontSize: "10px",
                    textTransform: "none",
                    marginTop: "3px",
                  }}
                >
                  VER
                </Button>

                <IconButton
                  onClick={() => reload()}
                  size="small"
                  sx={{
                    ...FilterButton,
                    marginTop: "1px",
                    marginLeft: "10px",
                  }}
                >
                  <EventRepeatIcon className="text-gris" fontSize="small" />
                </IconButton>
              </div>
            </div>

            <Divider sx={{ borderColor: "#484d50" }} />

            {/* Data */}

            <List
              className="max-h-[150px] overflow-y-auto"
              sx={{ width: "100%", top: "-15px" }}
            >
              {data?.map((item, index) => (
                <React.Fragment key={index}>
                  <ListItem
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "start",
                      gap: 1.5,
                      paddingY: 2,
                    }}
                  >
                    <div className="grid grid-cols-[60%_30%] gap-4 w-full">
                      <div className="flex w-full">
                        <p className="text-blanco text-[12px] text-justify">
                          {devolverNombre(name, item)}
                        </p>
                        <RadioButtonCheckedIcon
                          className={
                            item.status == "1" || item.state == "1"
                              ? "text-verde ml-3"
                              : "text-amarillo ml-3"
                          }
                        />
                      </div>

                      <div className="grid grid-cols-2 gap-8 ">
                        {button1_name !== null ? (
                          <Button
                            variant="contained"
                            sx={TableButton}
                            onClick={() => onClick1(name, item)}
                          >
                            {button1_name}
                          </Button>
                        ) : (
                          <div> </div>
                        )}

                        {button2_name !== null ? (
                          <Button
                            variant="contained"
                            sx={TableButton}
                            onClick={() => onClick2(name, item)}
                          >
                            {button2_name}
                          </Button>
                        ) : (
                          <div> </div>
                        )}
                      </div>
                    </div>
                  </ListItem>

                  <Divider sx={{ borderColor: "#484d50" }} />
                </React.Fragment>
              ))}
            </List>

            <p className="text-blanco text-[12px] ml-4 font-bold ">
              Total: {data?.length}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default AdminCard;
